module.exports = __webpack_public_path__ + "img/Plan de travail 35.b66aec8f.svg";